import { render } from "./LookupFilters.vue?vue&type=template&id=4fe3224f&ts=true"
import script from "./LookupFilters.vue?vue&type=script&lang=ts"
export * from "./LookupFilters.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__